import type {
  BillingReportAccountType,
  BillingReportDateBasis,
} from "../../services/reports.service";
import { DEFAULT_BILLING_REPORT_ACCOUNT_TYPE } from "../../services/reports.service";
import { AccountTypeFilter } from "./AccountTypeFilter";
import { BillingReportDateFilters } from "./BillingReportDateFilters";
import { DateRange } from "./ReportDateRangePicker";

interface BillingReportCoreFiltersProps {
  dateBasis: BillingReportDateBasis;
  accountType: BillingReportAccountType;
  dateRange: DateRange;
  onDateBasisChange: (value: string | null) => void;
  onAccountTypeChange: (value: string | null) => void;
  onDateRangeChange: (value: DateRange) => void;
}

export { DEFAULT_BILLING_REPORT_ACCOUNT_TYPE };

export function BillingReportCoreFilters({
  dateBasis,
  accountType,
  dateRange,
  onDateBasisChange,
  onAccountTypeChange,
  onDateRangeChange,
}: BillingReportCoreFiltersProps) {
  return (
    <>
      <BillingReportDateFilters
        dateBasis={dateBasis}
        dateRange={dateRange}
        onDateBasisChange={onDateBasisChange}
        onDateRangeChange={onDateRangeChange}
      />
      <AccountTypeFilter value={accountType} onChange={onAccountTypeChange} />
    </>
  );
}
